import { Link } from 'react-router-dom'
import { Logo } from '@/components/ui/Logo'
import { ArrowUpRight } from 'lucide-react'

export function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="relative bg-black">
      {/* Top Border Gradient */}
      <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />

      <div className="container mx-auto px-4 py-16">
        {/* Main Content */}
        <div className="flex flex-col md:flex-row justify-between items-start gap-12 mb-16">
          {/* Brand */}
          <div className="space-y-4 max-w-xs">
            <Logo size="lg" className="text-white" />
            <p className="text-xs text-gray-600 leading-relaxed">
              Este é um projeto independente e não possui qualquer vínculo, afiliação ou endosso oficial da marca Futura Broker.
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-col sm:flex-row gap-12 sm:gap-20">
            {/* Dashboard */}
            <div>
              <h4 className="text-[10px] font-semibold uppercase tracking-[0.2em] text-gray-500 mb-4">
                Dashboard
              </h4>
              <ul className="space-y-3">
                <li>
                  <Link
                    to="/dashboard"
                    className="group inline-flex items-center gap-1 text-sm text-gray-500 hover:text-white transition-colors"
                  >
                    <span>Conectar</span>
                    <ArrowUpRight className="w-3 h-3 opacity-0 -translate-y-0.5 translate-x-0.5 group-hover:opacity-100 group-hover:translate-y-0 group-hover:translate-x-0 transition-all" />
                  </Link>
                </li>
              </ul>
            </div>

            {/* Legal */}
            <div>
              <h4 className="text-[10px] font-semibold uppercase tracking-[0.2em] text-gray-500 mb-4">
                Legal
              </h4>
              <ul className="space-y-3">
                <li>
                  <Link
                    to="/terms"
                    className="group inline-flex items-center gap-1 text-sm text-gray-500 hover:text-white transition-colors"
                  >
                    <span>Termos de Uso</span>
                    <ArrowUpRight className="w-3 h-3 opacity-0 -translate-y-0.5 translate-x-0.5 group-hover:opacity-100 group-hover:translate-y-0 group-hover:translate-x-0 transition-all" />
                  </Link>
                </li>
                <li>
                  <Link
                    to="/privacy"
                    className="group inline-flex items-center gap-1 text-sm text-gray-500 hover:text-white transition-colors"
                  >
                    <span>Privacidade</span>
                    <ArrowUpRight className="w-3 h-3 opacity-0 -translate-y-0.5 translate-x-0.5 group-hover:opacity-100 group-hover:translate-y-0 group-hover:translate-x-0 transition-all" />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="relative pt-8">
          {/* Divider */}
          <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-white/[0.06] to-transparent" />

          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-xs text-gray-600">
              © {currentYear} zonisigma.app
            </p>
            <p className="text-xs text-gray-700">
              Todos os direitos reservados
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}
